import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppContextProvider from "./Context/authContext/AuthContextProvider"
import { BrowserRouter } from "react-router-dom"; 
import CartContextProvider from "./Context/CartContext/CartContextProvider"
import { ChakraProvider } from '@chakra-ui/react'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider>
  <BrowserRouter>
<AppContextProvider>
  <CartContextProvider>
    <App />
    </CartContextProvider>
    </AppContextProvider>
    </BrowserRouter>
    </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
